import PageHeader from "@/components/common/PageHeader";
import { Reveal } from "@/components/common/Reveal";
import { COMPANY } from "@/data/content";

const CONTENT = {
  privacy: {
    title: "Privacy Policy",
    eyebrow: "Legal",
    sections: [
      ["Information We Collect", "We collect information you voluntarily provide through our enquiry, quote and contact forms — including your name, email, phone number, company and message. This information is used solely to respond to your request and provide our services."],
      ["How We Use Your Data", "Your data is used to process enquiries, prepare quotations, deliver services and communicate with you. We do not sell or rent your personal information to third parties."],
      ["Data Security", "We implement appropriate technical and organisational measures to protect your data against unauthorised access, alteration or disclosure."],
      ["Your Rights", `You may request access to, correction of, or deletion of your personal data at any time by contacting us at ${COMPANY.email}.`],
      ["Cookies", "Our website may use essential cookies to ensure proper functionality. We do not use tracking cookies for advertising purposes."],
    ],
  },
  terms: {
    title: "Terms & Conditions",
    eyebrow: "Legal",
    sections: [
      ["Acceptance of Terms", "By accessing and using this website, you accept and agree to be bound by these terms and conditions."],
      ["Use of Website", "The content of this website is for general information and use only. It is subject to change without notice."],
      ["Quotations & Enquiries", "All quotations provided are indicative and subject to formal confirmation. Final pricing and specifications are confirmed in writing upon order."],
      ["Intellectual Property", "All content, branding and imagery on this website are the property of the company and may not be reproduced without permission."],
      ["Limitation of Liability", "We shall not be liable for any indirect or consequential loss arising from the use of this website or reliance on its content."],
      ["Governing Law", "These terms are governed by and construed in accordance with applicable local law."],
    ],
  },
};

const Legal = ({ type = "privacy" }) => {
  const c = CONTENT[type];
  return (
    <div>
      <PageHeader eyebrow={c.eyebrow} title={c.title} subtitle={`Last updated ${new Date().getFullYear()} · ${COMPANY.legal}`} />
      <section className="py-12 md:py-20">
        <div className="max-w-[820px] mx-auto px-6 md:px-12 space-y-10">
          {c.sections.map(([title, text], i) => (
            <Reveal key={title} delay={i * 0.04}>
              <h2 className="text-2xl">{title}</h2>
              <p className="mt-3 text-dim leading-relaxed">{text}</p>
            </Reveal>
          ))}
        </div>
      </section>
    </div>
  );
};

export default Legal;
